import { render } from "./PrintDocumentsSection.vue?vue&type=template&id=572618a0"
import script from "./PrintDocumentsSection.vue?vue&type=script&lang=js"
export * from "./PrintDocumentsSection.vue?vue&type=script&lang=js"

import "./PrintDocumentsSection.vue?vue&type=style&index=0&id=572618a0&lang=css"

import exportComponent from "../../../../../../procollege/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__